<template>
	<div class="max-w-xl m-auto">
		<h1 class="text-2xl font-bold md:text-3xl md:p-2">
			Welcome back
		</h1>
		<p class="text-base md:text-xl">
			Please login to continue using {{ APP_META.NAME }}.
		</p>
		<form
			id="loginForm"
			class="flex flex-col text-left"
			@submit.prevent="handleLogin"
		>
			<div class="my-4">
				<WwTextInput
					id="username"
					v-model="username"
					:value="username"
					name="username"
					:required="true"
					input-class="w-full"
					autocomplete="username"
					:state="inputFieldState(username, TEXT)"
					label="Username"
				/>
			</div>
			<WwTextInput
				id="password"
				v-model="password"
				:value="password"
				name="password"
				:input-type="PASSWORD"
				:required="true"
				input-class="w-full"
				autocomplete="password"
				:state="inputFieldState(password, PASSWORD)"
				label="Password"
			/>
			<div class="flex flex-col items-start justify-between py-3 sm:flex-row sm:items-center">
				<div class="flex items-center py-2 space-x-2">
					<input
						type="checkbox"
						class="text-green-500 rounded-sm focus:ring focus:ring-green-300"
					>
					<p>
						Remember me
					</p>
				</div>
				<router-link to="/forgot">
					<span class="font-bold hover:text-green-500">
						Forgot your password?
					</span>
				</router-link>
			</div>
			<WwSubmitButton
				:disabled="isDisabled"
				:is-loading="isLoading"
				button-text="Login"
			/>
		</form>
		<ClientOnly>
			<SocialLoginButtons
				class="w-full mx-auto"
				@logged-in="handleLoginClose"
			/>
		</ClientOnly>
	</div>
</template>

<script>
import ClientOnly from 'vue-client-only'
import {
	mapActions,
	mapMutations,
	mapState
} from 'vuex'

import WwSubmitButton from '@/components/UI/buttons/WwSubmitButton.vue'
import WwTextInput from '@/components/UI/WwTextInput.vue'
import { APP_META } from '@/constants/index.js'
import INPUT_STATES from '@/constants/text-inputs/states'
import {
	PASSWORD,
	TEXT
} from '@/constants/text-inputs/types'
import { logError } from '@/utils/error-handling.js'
import { inputFieldState } from '@/validators/text-inputs.js'

export default {
	components: {
		SocialLoginButtons: () => import('@/components/login/SocialLoginButtons.vue'),
		ClientOnly,
		WwTextInput,
		WwSubmitButton
	},
	props: {
		isModal: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			username: '',
			password: '',
			APP_META,
			PASSWORD,
			TEXT,
			inputFieldState,
			isLoading: false
		}
	},
	computed: {
		...mapState({
			lastRoute: (state) => { return state.lastRoute }
		}),
		routeTo() {
			switch (this.lastRoute) {
				case '/login':
					return '/'
				case '':
					return '/'
				default:
					return this.lastRoute
			}
		},
		isDisabled() {
			return this.username.length === 0 || this.password.length === 0
		}
	},
	methods: {
		...mapMutations('modal', [ 'closeModal' ]),
		...mapMutations('toast', [ 'showToast' ]),
		...mapActions('auth', [ 'logIn' ]),
		handleLoginClose() {
			if (this.isModal) {
				this.closeModal()
			} else {
				this.$router.push(this.routeTo)
			}
		},
		async handleLogin() {
			try {
				this.isLoading = true
				await this.logIn({
					username: this.username,
					password: this.password
				})
			} catch (e) {
				logError(e)
			} finally {
				this.isLoading = false
			}
		},
		fieldState(value) {
			return value?.length ? INPUT_STATES.SUCCESS : INPUT_STATES.ERROR
		}
	}
}
</script>
